import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UIVSCompare = {
    name: 'VS Vulnerability Lookup',
    imageUrl: '../../images/VSCompare.png',
    imageSize: "99%",
    bradius: 20,
  };


export const VSCompare = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Vulnerability Scan Compare</b><br/><br/>
      To compare and contrast your vulnerability mitigation progress, you can compare vulnerability 
      scan results for any specific target you have scanned. <br/><br/>
      
      To do so, first select the target from the drop-down list of targets with vulnerability scan history. <br/><br/>
      
      Now select the scans you want to compare. Select the Report Date and Scan Name for each 
      scan and click on Compare to view the comparison. Note that when selecting a report date, 
      it has to be a date for a previous vulnerability scan. <br/><br/>
      
      You will be presented with a simplified display highlighting the outline of vulnerabilities for 
      your previous scan versus your current scan.  

      </div>
      <div style={helpimg}>
      <img
        src={UIVSCompare.imageUrl}
        alt={'Image of ' + UIVSCompare.name}
        style={{
          width: UIVSCompare.imageSize,
          borderRadius: UIVSCompare.bradius,
        }}
      />
      </div>
    </div>
  );
};
